import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
  useMemo,
} from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import _ from 'lodash';

import styles from '../../styles/containers/Lightbox.scss';

import { __ } from '../../core/utils';

import {
  hideLightbox,
  readAttachmentVersionAnnotations,
  showLightbox,
} from '../../redux/actions/general/lightbox';

import ArrowLeftSmallIcon from '../../assets/images/arrow-left-small-40x40.svg';
import ArrowRightSmallIcon from '../../assets/images/arrow-right-small-40x40.svg';
import { CanvasWrapper } from './CanvasWrapper/CanvasWrapper';
import { useKeyboardShortcutHandler } from './hooks/useKeyboardShortcutHandler';
import PdfWrapper from './PdfWrapper/PdfWrapper';
import { withRouter } from 'react-router';

const Lightbox = ({
  active,
  images,
  hideLightbox,
  showLightbox,
  annotations,
  history,
  user_full_name,
}) => {
  const image = _.find(images, ['id', active]);
  const index = _.findIndex(images, ['id', active]);
  const isPdfFile = _.toLower(image?.ext) == 'pdf';
  const isPlanModule = history.location.pathname.includes('plans');

  // useEffect(() => {
  //   if (isPdfFile) return;

  //   setImageSize(null);
  //   if (!image?.download_url) return;

  //   let cancelled = false;

  //   const getImageSize = (url) =>
  //     new Promise((resolve, reject) => {
  //       const img = new Image();
  //       img.onload = () =>
  //         resolve({ width: img.naturalWidth, height: img.naturalHeight });
  //       img.onerror = reject;
  //       img.src = url;
  //     });

  //   getImageSize(image.download_url).then((size) => {
  //     if (!cancelled) {
  //       setImageSize(size);
  //     }
  //   });

  //   return () => {
  //     cancelled = true;
  //   };
  // }, [image?.download_url, isPdfFile]);

  useEffect(() => {
    const root = document.getElementById('root');

    if (active) {
      image?.download_url &&
        image?.attachment_version_id &&
        readAttachmentVersionAnnotations(image.attachment_version_id);

      root.classList.add('blur');
    } else root.classList.remove('blur');

    return () => root.classList.remove('blur');
  }, [active, image?.attachment_version_id]);

  const changeImage = useCallback(
    (index) => {
      const image = images[index];
      if (!image) return;

      showLightbox(images, image.id);
    },
    [images, showLightbox],
  );

  const { handleShortcut } = useKeyboardShortcutHandler({
    active,
    images,
    changeImage,
    hideLightbox,
  });

  if (!active) return null;

  return (
    <div className={classNames(styles.wrapper, isMobile && styles.mobile)}>
      {!isPdfFile ? (
        <CanvasWrapper
          image={image}
          annotations={annotations}
          disabled={isPlanModule}
        />
      ) : (
        <PdfWrapper
          file={image}
          user_full_name={user_full_name}
          annotations={annotations}
          disabled={isPlanModule}
        />
      )}

      <div className={styles.controls}>
        <div
          className={classNames(styles.left, index > 0 && styles.clickable)}
          onClick={() => index > 0 && changeImage(index - 1)}
        >
          {index !== 0 && <ArrowLeftSmallIcon />}
        </div>

        <div className={styles.gap} />

        <div
          className={classNames(
            styles.right,
            index < _.size(images) - 1 && styles.clickable,
          )}
          onClick={() => index < _.size(images) - 1 && changeImage(index + 1)}
        >
          {index !== _.size(images) - 1 && <ArrowRightSmallIcon />}
        </div>
      </div>

      <KeyboardEventHandler
        handleKeys={['up', 'down', 'left', 'right', 'esc']}
        onKeyEvent={handleShortcut}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...state.general.lightbox,
  user_full_name: state.auth.firstname + ' ' + state.auth.lastname,
  canvas_editor: state.canvas_editor,
});

const mapDispatchToProps = {
  hideLightbox,
  showLightbox,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Lightbox),
);
